// Universal pricing — single source of truth. Quote verbatim; show no other prices.
export const TIERS = [
  {
    name: "Founding paid pilot",
    price: "$1,000",
    priceSub: "No install fee",
    includes: null,
    highlight: true,
    testid: "tier-founding-pilot",
  },
  {
    name: "Core",
    price: "$1,500",
    priceSub: "/site/month",
    setup: "+ $5,000 setup",
    includes: "Includes WSafe AI, HazardLoop, WorkSafeStory.",
    testid: "tier-core",
  },
  {
    name: "Pro",
    price: "$3,000",
    priceSub: "/site/month",
    setup: "+ $10,000 setup",
    includes: "Includes everything in Core plus InductIQ and EnviSafe.",
    testid: "tier-pro",
  },
  {
    name: "Vision",
    price: "$6,250",
    priceSub: "/site/month",
    setup: "+ $25,000 setup",
    includes: "Includes everything in Pro plus SafeForm and continuous CCTV detection.",
    testid: "tier-vision",
  },
];

export const COMPLIANCE = {
  evaluation: "$1,500 evaluation",
  plans: [
    { name: "Essentials", price: "$500" },
    { name: "Standard", price: "$1,000" },
    { name: "Premium", price: "$2,000" },
  ],
  unit: "per site/month",
  notes: [
    "Billed in addition to a Core or Pro subscription.",
    "Covers OSHA and environmental records.",
    "Documentation setup is included in the setup fee; work beyond included hours is $150/hr.",
  ],
};

export const CONSULTING = [
  { label: "Hourly", price: "$150/hr" },
  { label: "Gap review", price: "$1,500" },
  { label: "Audit", price: "$1,500/day" },
  { label: "AI readiness assessment", price: "$2,500", note: "credited toward a paid pilot" },
  { label: "Retainer", price: "$1,200/month" },
];

export const CONSULTING_NOTE =
  "No travel charge for on-site work within 50 miles of Abilene, Texas.";
